"use strict";
// (C) 2021-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.configInitialState = void 0;
exports.configInitialState = { config: undefined };
//# sourceMappingURL=configState.js.map